import { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import Swal from "sweetalert2";
import * as actions from "../../../store/ducks/liveCasino/actions";
import * as currentUserActions from "../../../store/ducks/currentUser/actions";
import moment from "moment-timezone";
import { NavLink } from "react-router-dom";
import { isDesktop } from "react-device-detect";
import { detectCountry } from "../../../hoc/Shared/utility";

let dynamicCountry = detectCountry(window.location.host);

class LiveCasinoHeader extends Component{
    constructor(props){
        super(props);
        this.state = {
            loading: true,
            vendorList: []
        }
    }

    shouldComponentUpdate(nextProps, nextState){
        // console.log("[shouldComponentUpdate]",nextProps,nextProps.rs);
        if(nextProps.vendor!==undefined && nextProps.vendor!==this.props.vendor){
            if(nextProps.vendor.responseCode===200 && nextProps.vendor.msgType==="success"){
                let vendorList = nextProps.vendor.data.vendor_list;
                let liveCasinoVendor = [];
                if(vendorList.length>0){
                    vendorList.map((val,idx)=>{
                        if(val.game_type_slug==="ca"){
                            liveCasinoVendor.push(val);
                        }
                        return null;
                    });
                }
                this.setState({
                    loading: false,
                    vendorList: liveCasinoVendor
                });
            }
        }

        // still using?
        if(nextProps.rs !== undefined && nextProps.rs !== this.props.rs){
            if(nextProps.rs.responseCode === 200 && nextProps.rs.msgType === "success"){
                if(nextProps.liveCasino.actionFrom === "PageHeader"){
                    Swal.close();
                    if(nextProps.rs.data.hasOwnProperty("url")){
                        window.open(nextProps.rs.data.url);
                    }else if(nextProps.rs.data.hasOwnProperty("gameError")){
                        this.gameErrorResponse(nextProps.rs.data.gameError);
                    }
                }
            }else{
                const { t } = this.props;
                Swal.fire({
                    iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/mdi:close.svg?color=%23ffffff">' : "",
                    title:  t("global.failed"),
                    icon: "error",
                    html: `${t("global.error")} (${nextProps.rs.message[0]}). ${t("global.contact-administrator")}`,
                    showConfirmButton: true,
                    confirmButtonText: t("global.ok"),
                    customClass: (!isDesktop) ? {
                        container: "swal-mobile-container failed",
                        icon: "swal-failed-icon", 
                    } : [],
                });
            }
        }

        return true;
    }

    gameErrorResponse = (response) => {
        const { t } = this.props;

        switch (response.status) {
            case 1:
                Swal.fire({
                    iconHtml: (!isDesktop) ?  '<img src="https://api.iconify.design/mdi:exclamation.svg?color=%23ffffff">' : "",
                    title:  t("global.reminder"),
                    icon: "error",
                    html: `${t("global.error")} ${t("global.code")}: ${response.status} - ${t("global.kindly-refresh-the-page")}`, 
                    showConfirmButton: true,
                    confirmButtonText: `${t("global.refresh")}`,
                    customClass: (!isDesktop) ? {
                        container: "swal-mobile-container reminder",
                        icon: "swal-reminder-icon", 
                    } : [],
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                });
                break;
            case 2:
                const currentUserTimeZone = this.props.currentUser.data.time_zone;
                const startTime = moment(response.maintenance_start_time).tz(currentUserTimeZone === undefined ? "Asia/Kuala_Lumpur" : currentUserTimeZone).format('YYYY/MM/DD HH:mm:ss').toString();
                const endTime = moment(response.maintenance_end_time).tz(currentUserTimeZone === undefined ? "Asia/Kuala_Lumpur" : currentUserTimeZone).format('YYYY/MM/DD HH:mm:ss').toString();
                const timeZone = moment().tz(currentUserTimeZone === undefined ? "Asia/Kuala_Lumpur" : currentUserTimeZone).format('[(GMT] z[)]').toString();
                Swal.fire({
                    iconHtml: (!isDesktop) ?  '<img src="https://api.iconify.design/mdi:exclamation.svg?color=%23ffffff">' : "",
                    icon: "info",
                    titleText: `${t("global.under-maintenance")}`,
                    html: `${t("global.from")} <b>${startTime}</b> ${t("global.to")} <b>${endTime}</b> ${timeZone}`,
                    showConfirmButton: true,
                    confirmButtonText: t("global.ok"),
                    customClass: (!isDesktop) ? {
                        container: "swal-mobile-container reminder",
                        icon: "swal-reminder-icon", 
                    } : [],
                });
                break;
            case 3:
                Swal.fire({
                    iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/mdi:close.svg?color=%23ffffff">' : "",
                    title:  t("global.failed"),
                    icon: "error",
                    html: `${t("global.error")} ${t("global.code")}: ${response.status} - ${t("global.contact-administrator")}`,
                    showConfirmButton: true,
                    confirmButtonText: t("global.ok"),
                    customClass: (!isDesktop) ? {
                        container: "swal-mobile-container failed",
                        icon: "swal-failed-icon", 
                    } : [],
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                });
                break;
            default:
                Swal.fire({
                    iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/mdi:close.svg?color=%23ffffff">' : "",
                    title:  t("global.failed"),
                    icon: "error",
                    html: `${t("global.error")} ${t("global.code")}: 500 - ${t("global.contact-administrator")}`,
                    showConfirmButton: true,
                    confirmButtonText: t("global.ok"),
                    customClass: (!isDesktop) ? {
                        container: "swal-mobile-container failed",
                        icon: "swal-failed-icon", 
                    } : [],
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                });
                break;
        }
    };

    accessGame = (game) => {
        if(!localStorage.getItem("accessToken")){
            const { t } = this.props;
            Swal.fire({
                iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : '',
                icon: "info",
                title: t("global.sorry"),
                text: t("global.login-proceed"),
                confirmButtonText: t("global.ok"),
                customClass: (!isDesktop) ? {
                    container: 'swal-mobile-container sorry',
                    icon: 'swal-sorry-icon',
                } : [],
            });
        }else{
            localStorage.setItem("gameLauncher", 'casino|'+game);
            window.open('/game-launcher');
        }
    };

    render(){
        const { t } = this.props;
        let imgDropdown = this.props.imgDropdown;
        let liveCasino = this.state.vendorList ? this.state.vendorList : [];
        return (
            <>
                {(!this.state.loading && liveCasino) &&
                    liveCasino.slice(0,11).map((item, index) => {
                        if(item.maintenance_status===0){
                            return (
                                <div className="col-2" key={index} onClick={()=>this.accessGame(item.game_vendor_slug)}>
                                    <div className="dropdown-title">
                                        <img src={imgDropdown[`${item.game_vendor_slug}-dropdown.webp`]} alt="Dropdown Icon" />
                                        <p>{t(`vendor.${item.game_vendor_slug}`)}</p>
                                    </div>
                                    <img className="dropdown-img" src={imgDropdown[`${item.game_vendor_slug}-girl.webp`]} alt="Dropdown" />
                                </div>
                            );
                        }
                        else{
                            return (
                                <div className="col-2" key={index}>
                                    <div className="dropdown-title">
                                        <img src={imgDropdown[`${item.game_vendor_slug}-dropdown.webp`]} alt="Dropdown Icon" />
                                        <p>{t(`vendor.${item.game_vendor_slug}`)}</p>
                                    </div>
                                    <img className="dropdown-img" src={imgDropdown[`${item.game_vendor_slug}-girl.webp`]} alt="Dropdown" />
                                </div>
                            );
                        }
                    })
                }
                {
                    liveCasino.length >=11 && (
                        <div className="col-2">
                            <NavLink className="btn more-btn-blue" to={{pathname:`/online-live-games-${dynamicCountry.label}`}}>{t("page-header.more-live-casino")}</NavLink>
                        </div>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = state => {
    // console.log("[mapStateToProps]",state);
    return {
        vendor: state.general.vendor,
        liveCasino: state.liveCasino,
        rs: state.liveCasino.rs,
        currentUser: state.currentUser
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getVendorList: (params) => dispatch(actions.getVendorList(params)),
        accessGame: (params,vendor) => dispatch(actions.accessGame(params,vendor)),
        setGameQT: (params) => dispatch(currentUserActions.setGameQT(params)),
        setUrl: (params) => dispatch(currentUserActions.setUrl(params))
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(withNamespaces("translation")(LiveCasinoHeader));